if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    var swiper_js = new Swiper(".swiper-js", {
		slidesPerView: 1,
		loop: true,
        effect: "fade",
		navigation: {
			nextEl: ".swiper-button-next-slide",
			prevEl: ".swiper-button-prev-slide",
		},
	});

    var swiper_slider = new Swiper(".swiper-slider", {
		slidesPerView: 1,
		loop: true,
        effect: "fade",
		breakpoints: {
			340: {
				autoHeight: true,
			},
			1060: {
				autoHeight: false,
            },
		},
		navigation: {
			nextEl: ".swiper-button-next-slider",
			prevEl: ".swiper-button-prev-slider",
		},
	});

    var swiper_home = new Swiper(".swiper-home", {
		slidesPerView: 1,
		loop: true,
        effect: "fade",
		pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
	});

    var swiper_accommodations = new Swiper(".swiper-accommodations", {
		slidesPerView: 1,
		loop: true,
        effect: "fade",
		navigation: {
			nextEl: ".swiper-button-next-accommodations",
			prevEl: ".swiper-button-prev-accommodations",
		},
	});

    var swiperYears = new Swiper(".swiper-years", {
		slidesPerView: 4,
		loop: true,
        spaceBetween: 130,
		navigation: {
			nextEl: ".swiper-button-next-years",
			prevEl: ".swiper-button-prev-years",
		},
		breakpoints: {
			340: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1060: {
                slidesPerView: 4,
                spaceBetween: 130,
            },
		},
	});

    var swiperReviews = new Swiper(".swiper-reviews", {
		slidesPerView: 1,
		spaceBetween: 20,
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next-reviews",
			prevEl: ".swiper-button-prev-reviews",
		},
	});

    var swiperOurhotel = new Swiper(".swiper-ourhotel", {
		slidesPerView: 3,
		spaceBetween: 100,
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next-ourhotel",
			prevEl: ".swiper-button-prev-ourhotel",
		},
		breakpoints: {
			340: {
				slidesPerView: 1,
				spaceBetween: 10,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 50,
			},
			1060: {
                slidesPerView: 3,
                spaceBetween: 100,
            },
		},
	});

	//click menu
	$("#menu-js").click(function(){
		$("#header").addClass("active");
		$(".header__menu--nav").addClass("active");
		$(".header__menu--close").addClass("show");
		$(this).addClass("hide");
	});
	$(".header__menu--close").click(function(){
		$("#header").removeClass("active");
		$(".header__menu--nav").removeClass("active");
		$(".header__menu--btn").removeClass("hide");
		$(this).removeClass("show");
	});

	document.addEventListener('DOMContentLoaded', function() {
		
		//Header Element
		let privacyNavigationItems = document.querySelectorAll('#privary-navigation li');
	
		privacyNavigationItems.forEach(function(item) {
			let nestedUl = item.querySelector('ul');
			
			if (nestedUl) {
				item.addEventListener('mouseover', function() {
					let privacyNavigation = document.querySelector('#privary-navigation');
					privacyNavigation.classList.add('active');
				});
	
				item.addEventListener('mouseout', function() {
					let privacyNavigation = document.querySelector('#privary-navigation');
					privacyNavigation.classList.remove('active');
				});
			}
		});

		//Lbx
		let elements = document.querySelectorAll('[data-fancybox="accommodations"]');

		elements.forEach(function(element) {
			if (!element.hasAttribute('data-lbx-group')) {
				element.setAttribute('data-lbx-group', 'accommodations');
			}
			if (!element.hasAttribute('data-lbx-full')) {
				element.setAttribute('data-lbx-full', '');
			}
		});

		//specials
		let specialElements = document.querySelectorAll('.special');

        specialElements.forEach(function(specialElement) {
            specialElement.addEventListener('mouseover', function() {
                let offersListMain = this.querySelector('.offers__list__main');
                if (offersListMain) {
                    offersListMain.classList.add('active');
                }
            });

            specialElement.addEventListener('mouseout', function() {
                let offersListMain = this.querySelector('.offers__list__main');
                if (offersListMain) {
                    offersListMain.classList.remove('active');
                }
            });
        });

		//for Menus
		let btn = document.querySelectorAll('.menu-restaurant__tabs li');
		if (btn) {
			btn.forEach((element,i) => {
				
				element.addEventListener('click', _ => {
					btn.forEach(b => b.classList.remove('active'));
					element.classList.add('active');
		
					document.querySelectorAll('.menu__unitmenu').forEach(menu => {
						menu.classList.remove('active');
						if ( element.dataset.tag === menu.dataset.tag ) {
							menu.classList.add('active');
						}
					});
				});
		
				if (i === 0) element.click();
			});
		}

		var links = document.querySelectorAll('a[href^="#"]:not(.no-scroll)');
			links.forEach(function(link) {
				link.addEventListener('click', function(e) {
					e.preventDefault();
					var targetId = this.getAttribute('href').substring(1);
					var targetElement = document.getElementById(targetId);
					if (targetElement) {
						var offsetTop = targetElement.offsetTop;
						window.scrollTo({
							top: offsetTop,
							behavior: 'smooth'
						});

					}
			});
		});
	});
	

	//for Gallery tabs
	document.querySelectorAll('.gallery__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.gallery__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.gallery__unit').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});


})();
    let element = document.querySelector('[id^="eventsinquiry-"][id$="-form"]');
        if (element) {
            let newId = 'eventsinquiry-form';
            element.id = newId; 
            // console.log(`ID actualizado a: ${newId}`);
        } else {
        console.warn('No elements found.');
        }

setTimeout( () => { 
	if( document.querySelector('#teconsent a') ) {
		let test = document.querySelector('#teconsent a');
		console.log( test );
		test.setAttribute('aria-label', 'Tracking preferences view information');
	}
}, 300);